import api from './api';
import * as helpers from './helpers';
import authService from './authentication';

export { logger, initLogger, captureError } from './logger';
export { pingInternet } from './network';

const {
  userApi,
  sensorApi,
  farmApi,
  controlApi,
  plansApi,
  blockApi,
  satelliteApi,
  recommendationApi,
  scheduleApi,
  reportsApi,
} = api;

export {
  farmApi,
  userApi,
  sensorApi,
  controlApi,
  plansApi,
  blockApi,
  helpers,
  authService,
  satelliteApi,
  recommendationApi,
  scheduleApi,
  reportsApi,
};

export { default as constants } from './constants';

// export {logger, initLogger, captureError };
